// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"Heading_subtitle__6Runs","slide-in-out":"Heading_slide-in-out__0Yg_Q","fade-in-out":"Heading_fade-in-out__bfu1E"};